import {
  IMerchGroupCategory,
} from '@models/VendorVariant/i-vendor-variant';

export interface IBreadcrumb {
  title: string;
  slug: string;
}

export default function buildMerchGroupCategoryBreadcrumbs(
  merchGroupCategory?: IMerchGroupCategory,
  childMerchGroupCategories: IMerchGroupCategory[] = []
): IBreadcrumb[] {
  const basePath = '/shop';
  const breadcrumbs: IBreadcrumb[] = [];
  if (!merchGroupCategory) {
    return breadcrumbs;
  }

  const { parentMerchGroupCategory } = merchGroupCategory;
  const merchGroupCategories = [...childMerchGroupCategories, merchGroupCategory];

  if (parentMerchGroupCategory) {
    return buildMerchGroupCategoryBreadcrumbs(parentMerchGroupCategory, merchGroupCategories);
  }

  return [...merchGroupCategories]
    .reverse()
    .reduce<IBreadcrumb[]>((acc, next, idx) => {
      const { title, slug } = next;

      let prevSlug = basePath;
      if (idx > 0) {
        prevSlug = acc[idx - 1].slug;
      }

      acc.push({
        title,
        slug: `${prevSlug}/${slug}`
      });

      return acc;
    }, []);
}
